/* eslint-disable no-prototype-builtins */
//TODO:#type #code
import { Injectable } from '@angular/core';
import mediaFiles from '../../config/media.json';
import { UtilsService } from './utils.service';
import { InstructionService } from './instruction.service';

export enum MediaScope {
  BLOCK = 'block',
  TEST = 'test'
}

// type IMAGE is not yet implemented in study navigation / MediaDisplayComponent
export enum MediaType {
  PDF = 'pdf',
  IMAGE = 'image'
}

interface File {
  id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  name: any;
  description: string;
  placeholder: string;
  scope: MediaScope;
}

export interface ExtractedMediaFile {
  id: string;
  name: string;
  type: MediaType;
  description: string;
}

@Injectable({
  providedIn: 'root'
})
export class MediaLoaderService {
  private lookupTable;
  _mediaFiles = JSON.parse(JSON.stringify(mediaFiles));

  constructor(
    private utils: UtilsService,
    private instructionService: InstructionService
  ) {
    // Comment out the initialization (Currently no need for media)
    // TODO: Check if this adjustment does not break some code
    //this.lookupTable = this.initLookupTable();
  }

  public async initLookupTable() {
    const lookupTable = {};

    const files = await this.getMediaFiles();
    const mediaTypes = Object.getOwnPropertyNames(files);

    for (const mediaType of mediaTypes) {
      const mediaFiles: File[] = files[mediaType];

      for (const file of mediaFiles) {
        const { id, name, description, placeholder, scope } = file;

        if (!lookupTable.hasOwnProperty(placeholder)) {
          lookupTable[placeholder] = {};
        }

        this.addScope(lookupTable[placeholder], scope);

        // fix for images necessary as currently implicitly assumes file is a pdf
        let fileName: string;
        switch (typeof name) {
          case 'string': {
            fileName = name;
            break;
          }
          case 'object': {
            if (this.utils.isEmptyObject(name)) {
              fileName = '';
            } else if (typeof name[this.instructionService.getLanguageIdentifier()] !== 'undefined') {
              fileName = name[this.instructionService.getLanguageIdentifier()];
            }
            break;
          }
          default:
            fileName = '';
        }

        lookupTable[placeholder][scope].push({
          id,
          name: fileName,
          type: mediaType,
          description
        });
      }
    }

    this.lookupTable = lookupTable;
  }

  public async setMediaFiles(file) {
    this._mediaFiles = file;
  }

  extractMediaByPlaceholderAndScope(placeholder: string, scope: MediaScope): ExtractedMediaFile {
    const possibleMediaFiles = this.lookupTable[placeholder][scope];
    const randomIdx = this.utils.getRandomIndexForArray(possibleMediaFiles);
    const mediaFile = possibleMediaFiles[randomIdx];

    this.lookupTable[placeholder][scope] = possibleMediaFiles
      .slice(0, randomIdx)
      .concat(possibleMediaFiles.slice(randomIdx + 1));

    return mediaFile;
  }

  private addScope(table: object, scope: MediaScope) {
    if (table.hasOwnProperty(scope)) return;
    table[scope] = [];
  }

  private async getMediaFiles() {
    return this._mediaFiles;
  }
}
